import EducationComponent from './education_component'
import React, { forwardRef } from 'react'
import './education.scss'
var education_data = [
  {
    institution: 'NMIMS',
    education_sub_heading: 'MBA, BTech (Computer Engineering) | Mumbai',
    imagePath: process.env.PUBLIC_URL + '/images/nmims.webp',
    description:
      'Sam completed his post-graduation from NMIMS. It is among the top 30 institutes of the country.',
    link: 'https://www.nmims.edu/'
  }
]

const Education = forwardRef((props, ref) => {
  return (
    <div ref={ref} className='education_section'>
      <h1>Education</h1>
      {education_data.map((element, index) => (
        <EducationComponent
          imagePath={element.imagePath}
          institution={element.institution}
          education_sub_heading={element.education_sub_heading}
          description={element.description}
          link={element.link}
          key={`${element.institution}-${index}`}
        />
      ))}
    </div>
  )
})
export default Education
